// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a06a522b","239":"c1eaaaa6","455":"1d5ccca8"}[chunkId] + ".chunk.js";
};